<template>
  <div class="com-container">
    <div
      class="com-echarts"
      ref="rank_ref"
      :style="{ height: height + 'px' }"
    ></div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      chartInstance: {},
      rankData: {},
      timer: null,
      startValue: 0,
      endValue: 9,
      height: 0,
    };
  },
  props: ["dataOption"],
  created() {
    let length = Object.keys(this.dataOption).length;
    this.height = length * 40;
  },

  mounted() {
    this.initChart();
    //this.initData();
    //window.onresize = this.screenAdapter;
    window.addEventListener("resize", () => {
      this.screenAdapter();
    });
    this.screenAdapter();
  },
  destroyed() {
    window.removeEventListener("resize", this.screenAdapter);
    clearInterval(this.timer);
  },
  methods: {
    initChart() {
      const yData = Object.keys(this.dataOption);
      const xData = Object.values(this.dataOption);
      this.chartInstance = this.$echarts.init(this.$refs.rank_ref, this.theme);
      const initOption = {
        title: {
          text: "我的知识墙（识别您知识薄弱环节并针对性强化训练）",
          top: "15px",
          left: "3%",
        },
        grid: {
          top: "68px",
          left: "5%",
          right: "3%",
          bottom: "20px",
          containLabel: true,
          show: true,
        },
        toolbox: {
          top: "20px",
          right: "5%",
          feature: {
            saveAsImage: {
              type: "png",
            }
          }
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        dataZoom: [
          {
            show: false,
            type: "slider",
          },
        ],

        xAxis: {
          type: "value",
        },
        yAxis: {
          type: "category",
          data: yData,
          axisLabel: {
            show: false,
          },
          axisTick: {
            show: false,
          },
        },
        series: [
          {
            type: "bar",
            data: xData,
            barWidth: 28,
            barCategoryGap: "5",
            itemStyle: {
              barBorderRadius: [5, 5, 0, 0], // 上右下左圆角
              shadowBlur: 10,
              shadowColor: "rgba(0, 0, 0, 0.5)",
              shadowOffsetY: 2,
              color: new this.$echarts.graphic.LinearGradient(0, 0, 1, 0, [
                  { offset: 0, color: "#ccf7aa" },    // 起始：薄荷绿
                  { offset: 0.6, color: "#87e8de" },  // 中间：过渡浅青（调和两色）
                  { offset: 1, color: "#08aee0" }     // 结束：天蓝色
                ]),
              emphasis: {
                shadowOffsetY:-2,
                shadowColor: "0 5px 10px rgba(0, 0, 0, 0.2)"
              }
            },

            label: {
              show: true,
              fontStyle: "italic",
              fontWeight: 600,
              formatter: "{b}",
              color: "#0683b9", 
            },
          },
        ],
      };
      this.chartInstance.setOption(initOption);
      // 使用on方法绑定点击事件，参数 'click' 表示点击图表事件，第二个参数是回调函数
      this.chartInstance.on("click", (params) => {
        if (params.componentType === "series" && params.seriesType === "bar") {
          const clickedBarIndex = params.dataIndex;
          const clickedBarName = params.name;
          const clickedBarValue = params.value;
          console.log(
            `点击了柱状图的第${
              clickedBarIndex + 1
            }个柱子，名称：${clickedBarName}，数值：${clickedBarValue}`
          );
          // 这里可以根据需求执行更多自定义的操作，比如弹出提示框、发送请求等
          this.$emit("recommandTopic", null, clickedBarName);
        }
      });
    },
    screenAdapter() {
      this.chartInstance.resize();
    },
    startChartAnimation() {
      if (this.timer) {
        clearInterval(this.timer);
      }
      this.timer = setInterval(() => {
        this.startValue++;
        this.endValue++;
        if (this.endValue > this.rankData.length - 1) {
          this.startValue = 0;
          this.endValue = 9;
        }
        this.updateChart();
      }, 1500);
    },
  },
  watch: {
    theme() {
      this.chartInstance.dispose();
      this.initChart();
      this.screenAdapter();
      this.updateChart();
    },
  },
};
</script>

<style>
.com-container {
  max-height: 600px;
  overflow-y: scroll;
}
.com-echarts {
  min-width: 600px;
  min-height: 180px;
}
</style>